import { defineStore } from 'pinia'
import { ref } from 'vue'
import Cache from '@/utils/cache'
const accessTokenData = Cache.get('accessTokenData')
const clientData = Cache.get('clientData')

export const useUserStore = defineStore('user', () => {
    // 登陆凭证
    const accessToken = ref(accessTokenData.jiu_access_token ? accessTokenData.jiu_access_token : '')
    // client客户信息
    const client = ref(clientData)
    // token过期时间
    const tokenExpiresTime = ref(accessTokenData.expires_time ? accessTokenData.expires_time : 0)
    // 登陆状态
    const isLogin = client.value === false ? ref(false) : ref(client.value.is_login)
    // 登陆
    const login = (token) => {
        accessToken.value = token.jiu_access_token
        tokenExpiresTime.value = token.expires_time
        client.value = token.client
        isLogin.value = true
        Cache.add('clientData', token.client, token.tokenExpiresTime)
        Cache.add('accessTokenData', {
            jiu_access_token: token.jiu_access_token,
            expires_time: token.expires_time
        }, token.expires_time)
    }

    // 退出登陆
    const logout = () => {
        Cache.del('clientData')
        Cache.del('accessTokenData')
        accessToken.value = ''
        tokenExpiresTime.value = ''
        client.value = {}
        isLogin.value = false
    }

    const setClientData = (e) => {
        client.value = e
        Cache.add('clientData', e, tokenExpiresTime.value)
    }

    // 检测登陆状态
    const inspectLoginState = () => {
        let time = Date.parse(new Date()) / 1000
        let is_login = client.value.is_login
        if (is_login && tokenExpiresTime.value > 0 && tokenExpiresTime.value > time) {
            isLogin.value = true
            return true
        }
        isLogin.value = false
        return false
    }
    return {
        isLogin,
        accessToken,
        client,
        tokenExpiresTime,

        login,
        logout,
        setClientData,
        inspectLoginState
    }
})
